import * as React from 'react';
import SVG, { Props as SVGProps } from 'react-inlinesvg';

import EmptyIcon from 'vectors/icons/empty.svg';

export const SVGIcon: React.FC<SVGIconProps> = (props) => {
  if (props.src && props.type === 'image/svg+xml') {
    return (
      <SVG
        {...props}
        src={props.src}
      />
    );
  } else {
    return <EmptyIcon />;
  }
};

type SVGIconProps = Omit<SVGProps, 'src' | 'height' | 'width'> & {
  src?: string;
  height?: number;
  width?: number;
  type: string | undefined;
};
